import React, { FC } from 'react';
import DlpLayout from 'src/search/components/DlpLayout';
import type { DlpListingsProps } from 'src/search/components/DlpListings';
import DlpListings from 'src/search/components/DlpListings';
import type { LandingResults } from 'src/common/types/api/v4/search/v1/landing';
import { isValidCategorySlug } from 'src/search/utils/getPageDataFromBreadcrumbs';
import styles from './DlpListingsPopular.module.scss';

export type DlpListingsPopularProps = {
  topCategories: LandingResults['top_categories'];
  popularTitles?: string[];
} & Pick<DlpListingsProps, 'locationSlug'>;

const DlpListingsPopular: FC<DlpListingsPopularProps> = ({
  topCategories,
  popularTitles,
  locationSlug,
}) => (
  <DlpLayout>
    <div className={styles.root}>
      {topCategories?.map((topCategory, index) => {
        const slug = topCategory?.slug.split('/')[0];
        const validCategorySlug = isValidCategorySlug(slug) ? slug : null;
        return (
          <DlpListings
            key={topCategory?.slug}
            title={popularTitles?.[index]}
            listings={topCategory?.results ?? []}
            categorySlug={validCategorySlug}
            locationSlug={locationSlug}
            data-gulper-section="MostPopular"
          />
        );
      })}
    </div>
  </DlpLayout>
);

export default DlpListingsPopular;
